import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        background: {
            paddingLeft: '60px',
        },
        container: {
            padding: 0,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            width: '100%',
            position: 'relative',
        },
        questions: {
            flex: '1 0 400px',
            display: 'flex',
            flexDirection: 'column'
        }, 
        counter: {
            position: 'absolute',
            top: '2px',
            left: '-60px',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: colors.color1,
            borderRadius: 1,
            '& p': {
                color: colors.color5,
            }
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: 1,
            justifyContent: 'space-between',
        },
        headerTitle: {
            wordBreak: 'break-word'
        },
        actions: {
            textDecoration: 'line-through',
            '&.active': {
                color: colors.primary,
                textDecoration: 'none',
                fontWeight: '600'
            }
        },
        answers: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        maxScroll: {
            maxHeight: '400px',
            overflow: 'auto'
        },
        answersMultiple: {
            width: '100%',
            gap: 2,
            [breakpoints.up('lg')]: {
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: ''
            }
        },
        marginTop: {
            [breakpoints.down('lg')]: {
                marginTop: '16px'
            }
        },
        containerAnswer: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        item1: { flex: '1 0 400px' },
        item2: { flex: '1 0 300px' },
        hiddenItemDown: {
            flex: '1 0 300px',
            [breakpoints.between(1535, 1630)]: {
                display: 'none'
            },
            border: `1px solid ${colors.color4}`,
        },
        hiddenItemUp: {
            display: 'none',
            [breakpoints.between(1535, 1630)]: {
                display: 'block',
                flex: '1 0 300px',
            }
        },
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '90vh', 
        },
    }
}

export { useStyles }